import React from 'react';
import { Box, IconButton, Typography, Select, MenuItem, FormControl } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export default function PageNavigator({
  page,
  setPage,
  totalPages,
  perPage,
  setPerPage,
}) {
  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePageChange = (e) => {
    setPage(Number(e.target.value));
  };

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setPage(1); // Reset to first page when perPage changes
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 1,
        py: 0.5,
        bgcolor: '#f9f9f9',
        borderTop: '1px solid #ddd',
        position: 'sticky',
        bottom: 0,
        zIndex: 999,
        width: '100%',
      }}
    >
      <Box display="flex" alignItems="center">
        <IconButton onClick={handlePrev} disabled={page <= 1} size="small">
          <ChevronLeftIcon fontSize="large" />
        </IconButton>

        <Typography variant="body2" sx={{ mr: 1, verticalAlign: 'center' }}>
        Page&nbsp;
        </Typography>

          <FormControl sx={{ m: 1, minWidth: 60 }} size="small">
          <Select
            value={page}
            onChange={handlePageChange}
            size="small"
            sx={{ minWidth: 60, fontSize: '0.875rem' }}
          >
            {Array.from({ length: totalPages }, (_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </Select>
          </FormControl>
        <Typography>
          &nbsp;of {totalPages}
        </Typography>

        <IconButton onClick={handleNext} disabled={page >= totalPages} size="small">
          <ChevronRightIcon fontSize="large" />
        </IconButton>
      </Box>

      <Box display="flex" alignItems="center">
      <Typography variant="body2" sx={{ ml: 1 }}>
          Show &nbsp;
        </Typography>
        <FormControl sx={{ m: 1, minWidth: 60 }} size="small">
        <Select
          value={perPage}
          onChange={handlePerPageChange}
          size="small"
          sx={{ minWidth: 70, fontSize: '0.875rem' }}
        >
          {[5, 10, 25, 50, 100].map((count) => (
            <MenuItem key={count} value={count}>
              {count}
            </MenuItem>
          ))}
        </Select>
        </FormControl >
        <Typography variant="body2" sx={{ ml: 1 }}>
          Records per page
        </Typography>
      </Box>
    </Box>
  );
}
